(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  // Reuse the collection wishlist data, but use cart-specific controls
  // to avoid interfering with theme or collection button handlers.
  (() => {
    if (window.__vilkonCartWishlistReady) return;
    window.__vilkonCartWishlistReady = true;
    const key = 'vilkon-collection-wishlist-v1';
    let fallback = [];
    const read = () => {
      try {
        const data = JSON.parse(window.localStorage.getItem(key) || '[]');
        if (Array.isArray(data)) return data.filter(p => p && p.id && p.title && p.url);
      } catch (_) {}
      return fallback;
    };
    const save = (list) => {
      fallback = list;
      try { window.localStorage.setItem(key, JSON.stringify(list)); } catch (_) {}
    };
    const sync = () => {
      const saved = new Set(read().map(p => String(p.id)));
      document.querySelectorAll('[data-vilkon-cart-wishlist-toggle]').forEach(btn => {
        btn.setAttribute('aria-pressed', saved.has(String(btn.dataset.productId)) ? 'true' : 'false');
      });
    };
    document.addEventListener('click', event => {
      const btn = event.target.closest('[data-vilkon-cart-wishlist-toggle]');
      if (!btn) return;
      event.preventDefault();
      const id = String(btn.dataset.productId || '');
      if (!id) return;
      const list = read();
      const index = list.findIndex(p => String(p.id) === id);
      if (index >= 0) list.splice(index, 1);
      else list.push({id, title: btn.dataset.productTitle || '', url: btn.dataset.productUrl || '', image: btn.dataset.productImage || ''});
      save(list);
      sync();
    });
    document.addEventListener('shopify:section:load', sync);
    window.addEventListener('storage', sync);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true});
    else sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }


  // Collection-only wishlist: local to this browser/device (no server account synchronization).
  (() => {
    const storageKey = 'vilkon-collection-wishlist-v1';
    let memoryFallback = [];

    const readSaved = () => {
      try {
        const raw = window.localStorage.getItem(storageKey);
        if (!raw) return memoryFallback;
        const data = JSON.parse(raw);
        if (Array.isArray(data)) return data.filter((item) => item && item.id && item.url && item.title);
      } catch (error) {
        // LocalStorage might be disabled by the browser.
      }
      return memoryFallback;
    };

    const writeSaved = (items) => {
      memoryFallback = items;
      try { window.localStorage.setItem(storageKey, JSON.stringify(items)); } catch (error) { /* session only */ }
    };

    const syncButtons = () => {
      const saved = readSaved();
      const ids = new Set(saved.map((item) => String(item.id)));
      document.querySelectorAll('[data-vilkon-wishlist-toggle]').forEach((button) => {
        const pressed = ids.has(button.dataset.productId);
        const value = pressed ? 'true' : 'false';
        if (button.getAttribute('aria-pressed') !== value) button.setAttribute('aria-pressed', value);
      });
      document.querySelectorAll('[data-vilkon-wishlist-count]').forEach((counter) => {
        const value = String(saved.length);
        if (counter.textContent !== value) counter.textContent = value;
      });
    };

    const renderWishlist = (dialog) => {
      const list = dialog.querySelector('[data-vilkon-wishlist-list]');
      const empty = dialog.querySelector('[data-vilkon-wishlist-empty]');
      if (!list) return;
      list.replaceChildren();
      const saved = readSaved();
      if (empty) empty.hidden = saved.length !== 0;

      saved.forEach((item) => {
        if (!item.url.startsWith('/') || item.url.startsWith('//')) return;
        const row = document.createElement('div');
        row.className = 'vilkon-wishlist-dialog__row';
        if (item.image && (item.image.startsWith('/') || item.image.startsWith('https://'))) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          img.loading = 'lazy';
          row.appendChild(img);
        }
        const link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.title;
        row.appendChild(link);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.dataset.vilkonWishlistRemove = item.id;
        remove.setAttribute('aria-label', 'Remove from favorites');
        remove.textContent = '\u00d7';
        row.appendChild(remove);
        list.appendChild(row);
      });
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-vilkon-wishlist-toggle]');
      if (toggle) {
        event.preventDefault();
        const id = toggle.dataset.productId;
        if (!id) return;
        const saved = readSaved();
        const existing = saved.findIndex((item) => String(item.id) === id);
        if (existing >= 0) saved.splice(existing, 1);
        else saved.push({
          id,
          title: toggle.dataset.productTitle || '',
          url: toggle.dataset.productUrl || '',
          image: toggle.dataset.productImage || ''
        });
        writeSaved(saved);
        syncButtons();
        return;
      }

      const open = event.target.closest('[data-vilkon-wishlist-open]');
      if (open) {
        const parent = open.closest('collection-component');
        const dialog = parent && parent.querySelector('[data-vilkon-wishlist-dialog]');
        if (dialog) {
          renderWishlist(dialog);
          if (!dialog.open) dialog.showModal();
        }
        return;
      }

      const close = event.target.closest('[data-vilkon-wishlist-close]');
      if (close) {
        const dialog = close.closest('dialog');
        if (dialog) dialog.close();
        return;
      }

      const remove = event.target.closest('[data-vilkon-wishlist-remove]');
      if (remove) {
        const id = remove.dataset.vilkonWishlistRemove;
        writeSaved(readSaved().filter((item) => String(item.id) !== id));
        syncButtons();
        const dialog = remove.closest('dialog');
        if (dialog) renderWishlist(dialog);
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.matches('[data-vilkon-wishlist-dialog]')) event.target.close();
    });
    window.addEventListener('storage', syncButtons);
    document.addEventListener('shopify:section:load', syncButtons);

    const start = () => {
      syncButtons();
      if (typeof MutationObserver === 'undefined') return;
      const observer = new MutationObserver((mutations) => {
        const newlyAddedCard = mutations.some(({ addedNodes }) => Array.from(addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches?.('[data-vilkon-wishlist-toggle]') || node.querySelector?.('[data-vilkon-wishlist-toggle]'))
        ));
        if (newlyAddedCard) syncButtons();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();

  } catch(e) { console.error(e); }
})();
})();
